<template>
  <div v-if="modal" class="modal-backdrop" @mousedown.self="close(null)">
    <div class="modal-box">
      <div class="modal-title">{{ modal.title }}</div>
      <div v-if="modal.html" class="modal-body" v-html="modal.html"></div>
      <textarea v-if="modal.textarea !== undefined" ref="textarea" v-model="text" class="modal-textarea" spellcheck="false"></textarea>
      <div v-if="error" class="modal-error">{{ error }}</div>
      <div class="modal-buttons">
        <button v-if="modal.cancel" class="secondary" @click="close(null)">{{ modal.cancel }}</button>
        <button @click="confirm">{{ modal.ok || 'OK' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
// Modal genérico. Uso: this.$refs.modal.open({ title, html, textarea, ok, cancel, validate })
// devolve uma Promise com o texto (textarea), true (confirmado) ou null (cancelado).
export default {
  data() {
    return { modal: null, text: '', error: '', resolve: null };
  },
  mounted() {
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    onKeydown(event) {
      if (this.modal && event.key === 'Escape') {
        this.close(null);
      }
    },
    open(options) {
      this.modal = options;
      this.text = options.textarea || '';
      this.error = '';
      this.$nextTick(() => this.$refs.textarea && this.$refs.textarea.focus());
      return new Promise(resolve => { this.resolve = resolve; });
    },
    confirm() {
      const value = this.modal.textarea !== undefined ? this.text : true;
      if (this.modal.validate) {
        const error = this.modal.validate(value);
        if (error) {
          this.error = error;
          return;
        }
      }
      this.close(value);
    },
    close(value) {
      const resolve = this.resolve;
      this.modal = null;
      this.resolve = null;
      if (resolve) resolve(value);
    }
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-box {
  background: #1a202c;
  color: #e2e8f0;
  border-radius: 6px;
  width: min(640px, calc(100vw - 32px));
  max-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  padding: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}
.modal-title {
  font-size: 1.6rem;
  font-weight: bold;
  margin-bottom: 12px;
}
.modal-body {
  overflow-y: auto;
  font-size: 1.3rem;
  line-height: 1.5;
}
.modal-body >>> table { width: 100%; border-collapse: collapse; }
.modal-body >>> td { padding: 3px 6px; border-bottom: 1px solid #2d3748; }
.modal-body >>> kbd { background: #2d3748; border-radius: 3px; padding: 1px 5px; font-family: monospace; }
.modal-body >>> a { color: #63b3ed; }
.modal-textarea {
  min-height: 300px;
  font-family: monospace;
  font-size: 1.3rem;
  background: #011627;
  color: #d6deeb;
  border: 1px solid #2d3748;
  border-radius: 4px;
  padding: 8px;
  resize: vertical;
}
.modal-error {
  color: #fc8181;
  margin-top: 8px;
  font-size: 1.2rem;
}
.modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}
.modal-buttons button {
  padding: 6px 16px;
  border: none;
  border-radius: 4px;
  background: #007bff;
  color: white;
  cursor: pointer;
  font-size: 1.3rem;
}
.modal-buttons button.secondary { background: #4a5568; }
.modal-buttons button:hover { filter: brightness(1.15); }
</style>
